import {PACKAGE_METADATA_TYPE_HTML, PACKAGE_METADATA_TYPE_JSON} from "../../components/package-metadata-viewer";
import {
  APP_LICENSE_FETCH,
  PACKAGE_LOADED,
  PACKAGE_METADATA_CLEAR,
  PACKAGE_METADATA_FETCH,
  PACKAGE_METADATA_SCHEMA_FETCH,
  PACKAGE_UNLOADED,
  REDIRECT_URL_SET,
  REDIRECT_URL_UNSET
} from "./miscellaneousActions";
import {getActionExtras, getAppConfig} from "../../middlewares/action-decorator/middlewareFactory";
import {REQUEST_ERROR, REQUEST_SUCCESS} from "../../middlewares/request/requestActions";
import {parseJsonMetadata} from "../../utils/metadata";

// Package Metadata handling
const initialStateMetadata = {
  packageMetadataSchema: null,
  packageMetadataFetched: false,
  packageMetadataHtml: null,
  packageMetadataJson: null,
  packageMetadataUrl: false
};

const initialState = {
  // Package Metadata handling
  ...initialStateMetadata,
  // Global Redirect
  redirectUrl: null,
  // License Info handling
  license: null
};

const miscellaneousReducer = (state = initialState, action) => {
  switch (action.type) {
    case REDIRECT_URL_SET:
      return {
        ...state,
        redirectUrl: action.payload.url
      };

    case REDIRECT_URL_UNSET:
      return {
        ...state,
        redirectUrl: null
      };
    case PACKAGE_LOADED:
    case PACKAGE_UNLOADED:
    case PACKAGE_METADATA_CLEAR: {
      return {
        ...state,
        ...initialStateMetadata
      };
    }
    case REQUEST_SUCCESS: {
      switch (action.payload.label) {
        case PACKAGE_METADATA_SCHEMA_FETCH: {
          return {
            ...state,
            packageMetadataSchema: action.payload.response.value?.properties
          };
        }
        case PACKAGE_METADATA_FETCH: {
          const {language, languages} = getActionExtras(action);
          const {dateFormat} = getAppConfig(action);

          const metadataType = action.payload.extra.metadataType;

          const metadataJson =
            metadataType === PACKAGE_METADATA_TYPE_JSON && action.payload.response
              ? parseJsonMetadata(action.payload.response, language, languages, dateFormat, state.packageMetadataSchema)
              : null;

          const metadataHtml =
            metadataType === PACKAGE_METADATA_TYPE_HTML && (action.payload.response || "").length > 0
              ? action.payload.response
              : null;

          return {
            ...state,
            packageMetadataFetched: true,
            packageMetadataJson: metadataJson,
            packageMetadataHtml: metadataHtml,
            packageMetadataUrl: Boolean(!metadataJson && !metadataHtml)
          };
        }
        case APP_LICENSE_FETCH: {
          const features = action.payload.response?.features
            ? Object.entries(action.payload.response.features).reduce(
                (features, [key, value]) => {
                  if (value === "True" || value === "False") {
                    features.booleans[key] = value;
                  } else if (value) {
                    features.others[key] = value;
                  }
                  return features;
                },
                {booleans: {}, others: {}}
              )
            : null;

          return {
            ...state,
            license: {
              ...action.payload.response,
              features: features
            }
          };
        }
        default:
          return state;
      }
    }
    case REQUEST_ERROR: {
      switch (action.payload.label) {
        case PACKAGE_METADATA_FETCH: {
          return {
            ...state,
            ...initialStateMetadata,
            packageMetadataFetched: true
          };
        }
        default:
          return state;
      }
    }
    default:
      return state;
  }
};

export default miscellaneousReducer;
